  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" name="loadingReportCsv" size="medium" color="#fff"
    type="ball-pulse" [fullScreen]="false">
    <p style="color: white" class="text-center"> En proceso ... </p>
  </ngx-spinner>

<div class="container py-3" style="max-width: 1000px;">

  <ng-container >
    <!-- Filtros y Evaluación -->
  <div class="mb-4 p-3 border rounded bg-light y-form-containe">
    <label class="bg-subtitle d-block mb-3 fw-semibold">Filtros:</label>

    <div class="row">

      <div class="col-12 mb-2">
        <div class="row">
          <div class="col-4">
            <div class="p-field row">
              <label for="evaluatedEvents" class="form-label col-12 fw-semibold d-block">Filtrar por:</label>
    
              <p-dropdown
                [options]="listOptions"
                [(ngModel)]="filterVehiclesBy"
                (onChange)="onVehicleFilterChange()"
                optionValue="valueOption"
                optionLabel="idOption"
                [appendTo]="'body'"
                class="limited-width-dropdown col-12"
              ></p-dropdown>
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-12 mb-2">
        <div class="row">
          <div class="col-4" *ngIf="!disabledOperation">
            <div class="p-field row">
              <label for="evaluatedEvents" class="form-label col-12 fw-semibold d-block">Operaciones:</label>
              <p-dropdown
                [options]="operations"
                [(ngModel)]="selectedOperation"
                optionLabel="nameoperation"
                optionValue="idoperation"
                [appendTo]="'body'"
                (onChange)="onChangeOperation()"
                [disabled]="operations.length <= 0"
                class="limited-width-dropdown col-12"
                [placeholder]="placeholderOperation"
              ></p-dropdown>
            </div>
          </div>
    
          <div class="col-4" *ngIf="!disabledGroup">
            <div class="p-field row">
              <label for="evaluatedEvents" class="form-label col-12 fw-semibold d-block">Grupos:</label>
              <p-dropdown
                [options]="groups"
                [(ngModel)]="selectedGroup"
                optionLabel="namegrupo"
                optionValue="idgrupo"
                [appendTo]="'body'"
                (onChange)="onChangeGrupos()"
                [disabled]="groups.length <= 0"
                class="limited-width-dropdown col-12"
                [placeholder]="placeholderGroup"
              ></p-dropdown>
            </div>
          </div>
    
          <div class="col-4" *ngIf="!disabledConvoy">
            <div class="p-field row">
              <label for="evaluatedEvents" class="form-label col-12 fw-semibold d-block">Convoys:</label>
              <p-dropdown
                [options]="convoys"
                [(ngModel)]="selectedConvoy"
                optionLabel="nameconvoy"
                optionValue="idconvoy"
                [appendTo]="'body'"
                (onChange)="onChangeConvoys()"
                [disabled]="convoys.length <= 0"
                class="limited-width-dropdown col-12"
                [placeholder]="placeholderConvoy"
              ></p-dropdown>
            </div>
          </div>
        </div>
      </div>



      <div class="col-4">
        <div class="p-field row">
          <label for="vehicles" class="form-label col-12 fw-semibold">Vehículos:</label>
          <p-multiSelect
            name="vehicles"
            [options]="selectableVehicles"
            [(ngModel)]="selectedVehicles"
            (ngModelChange)="validateDateTimeRange()"
            optionLabel="name"
            [showToggleAll]="true"
            [appendTo]="'body'"
            placeholder="Seleccione vehículos"
            [selectedItemsLabel]="'{0} vehículos seleccionados'"
            class="col-12 fixed-width-multiselect"
          ></p-multiSelect>
        </div>
      </div>

      <div class="col-4">
        <div class="p-field row">
          <label for="events" class="form-label col-12 fw-semibold">Eventos:</label>
          <p-multiSelect
            id="events"
            name="events"
            [options]="events"
            [(ngModel)]="selectedEvents"
            (ngModelChange)="validateDateTimeRange()"
            optionLabel="name_event"
            [showToggleAll]="true"
            [appendTo]="'body'"
            placeholder="Seleccione eventos"
            [selectedItemsLabel]="'{0} eventos seleccionados'"
            class="col-12 fixed-width-multiselect"
          ></p-multiSelect>
        </div>
      </div>
      <div class="col-4">
        <div class="p-field row">
          <label for="evaluatedEvents" class="form-label col-12 fw-semibold d-block">¿Eventos evaluados?</label>

          <p-dropdown
            id="evaluatedEvents"
            [options]="eventEvaluationOptions"
            [(ngModel)]="selectedEventEvaluation"
            optionLabel="label"
            placeholder="Todos"
            [appendTo]="'body'"
            class="limited-width-dropdown col-12"
          ></p-dropdown>
        </div>
      </div>
    </div>

  </div>

    <!-- Fechas y horas -->
    <div class="mb-4 p-3 border rounded bg-light">
      <label class="bg-subtitle d-block mb-3 fw-semibold">Límite de tiempo:</label>
      <div class="row g-3">
        <div class="col-md-6">
          <div class="p-field">
            <label for="dateInit" class="form-label">Fecha inicio:</label>
            <p-calendar
              id="dateInit"
              name="dateInit"
              [(ngModel)]="dateInit"
              (ngModelChange)="validateDateTimeRange()"
              dateFormat="dd/mm/yy"
              [maxDate]="dateEnd"
              [yearNavigator]="true"
              [monthNavigator]="true"
              yearRange="{{strYearRange}}"
              [appendTo]="'body'"
              class="w-100"
            ></p-calendar>
          </div>
  
          <div class="p-field mt-3">
            <label for="timeInit" class="form-label">Hora inicio:</label>
            <p-calendar
              id="timeInit"
              name="timeInit"
              [(ngModel)]="timeInit"
              (ngModelChange)="validateDateTimeRange()"
              [timeOnly]="true"
              [appendTo]="'body'"
              class="w-100"
              [yearNavigator]="true"
              [monthNavigator]="true"
              yearRange="{{strYearRange}}"
            ></p-calendar>
          </div>
        </div>
  
        <div class="col-md-6">
          <div class="p-field">
            <label for="dateEnd" class="form-label">Fecha final:</label>
            <p-calendar
              id="dateEnd"
              name="dateEnd"
              [(ngModel)]="dateEnd"
              (ngModelChange)="validateDateTimeRange()"
              dateFormat="dd/mm/yy"
              [minDate]="dateInit"
              [maxDate]="today"
              [appendTo]="'body'"
              [yearNavigator]="true"
              [monthNavigator]="true"
              yearRange="{{strYearRange}}"
              class="w-100"
            ></p-calendar>
          </div>
  
          <div class="p-field mt-3">
            <label for="timeEnd" class="form-label">Hora final:</label>
            <p-calendar
              id="timeEnd"
              name="timeEnd"
              [(ngModel)]="timeEnd"
              (ngModelChange)="validateDateTimeRange()"
              [maxDate]="today"
              [timeOnly]="true"
              [appendTo]="'body'"
              [yearNavigator]="true"
              [monthNavigator]="true"
              yearRange="{{strYearRange}}"
              class="w-100"
            ></p-calendar>
          </div>
        </div>
      </div>
  
      <div class="row mt-3 justify-content-end">
        <div class="col-auto text-danger" *ngIf="!areHoursValid">
          * La hora de inicio no puede ser mayor a la hora final
        </div>
         <div class="col-auto text-danger" *ngIf="isRangeExceeded">
          * El rango de fechas no puede ser mayor a 32 días
        </div>
      </div>
    </div>
  
    <!-- Botón enviar -->
    <div class="row mt-4">
      <div class="col text-end">
        <button
          class="btn btn-primary"
          (click)="enviarPeticion()"
          [disabled]="
            !areHoursValid ||
            selectedVehicles.length === 0 ||
            selectedEvents.length === 0
          "
        >
          Enviar
        </button>
      </div>
    </div>
  </ng-container>

  <div *ngIf="fileInfo && !csvLoading" class="mt-4 p-3 border rounded bg-light">
  <h5 class="fw-bold mb-3">Resumen del archivo CSV:</h5>
  <ul class="mb-0">
    <li><strong>Tamaño del archivo:</strong> {{ fileInfo.sizeKB }} KB</li>
    <li><strong>Total de filas:</strong> {{ fileInfo.rows }}</li>
    <li><strong>Total de columnas:</strong> {{ fileInfo.columns }}</li>
  </ul>
</div>
</div>
